<label
  [for]="inputControlName"
  class="base-form__label"
  [class.base-form__label--required]="required"
  >{{ labeltext }}</label>
<div [formGroup]="form" class="base-form__input-container">
  <input
    [formControlName]="inputControlName"
    [class.base-field--error]="control?.invalid && control?.touched"
    [class.base-field--typed]="control?.value"
    [class.base-field--disabled]="disabled"
    [class.base-field--centered]="center"
    class="base-field"
    [placeholder]="placeholder"
    [type]="type"
    (blur)="onBlur($event)"
    (keydown)="onKeydown($event)"
    [readonly]="readonly"
  />
  @if (control?.invalid && control?.touched) {
    <span class="material-symbols-outlined base-field__error-icon">cancel</span>
  }
</div>
@if (infoText) {
  <small class="base-field__info-text">{{ infoText }}</small>
}
@if (errors && errors.length > 0) {
  <small class="base-field__error">{{ errors[0] }}</small>
}
